import * as React from 'react';

import './Section.css';

interface SectionProps {
  title: string;
  className?: string;
  children: JSX.Element | JSX.Element[];
}

export const Section = ({title, children, className}: SectionProps) => {
  return (
    <div className={'Section ' + className}>
      <span className="title text-muted">{title}</span>
      {children}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/DocView/Section/Section.tsx